// extracted by mini-css-extract-plugin
export default {"Form":"dy1mDuWW","ModalForm":"PaSbThvG"};